import { render, staticRenderFns } from "./CartProduct.vue?vue&type=template&id=a21af4b6&"
import script from "./CartProduct.vue?vue&type=script&lang=js&"
export * from "./CartProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports